import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { isEmpty, get } from 'lodash';
import { Link } from 'react-router-dom';
import { v4 as uuid } from 'uuid';
import AssetSelection from './AssetSelection';
import SectionSelect from './SectionSelect';
import VerbButton, { VERB_BUTTON_TYPE } from '../../../../shared/components/VerbButton';
import { SECTION_ITEM_TYPES } from '../../../../shared/Constants';

class CopySectionForm extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            copyFrom: {},
            copyTo: {},
            selectedItems: {},
            submitting: false,
            submitMessage: ''
        };
    }

    static propTypes = {
        assetsById: PropTypes.object,
        onLearningAssetSelect: PropTypes.func,
        onSubmit: PropTypes.func,
        onCancel: PropTypes.func,
        learningAssets: PropTypes.array
    };

    onAssetChange = (learningAssetId, stateKey) => {
        const { assetsById = {}, onLearningAssetSelect } = this.props;
        if (assetsById[learningAssetId]) {
            return onLearningAssetSelect(learningAssetId).then((learningAsset) =>
                this.setState(() => {
                    const newState = { [stateKey]: learningAsset };
                    if (stateKey === 'copyFrom') {
                        newState.selectedItems = {};
                    }
                    return newState;
                })
            );
        }
        return null;
    };

    onSectionChange = (value, active) => {
        this.setState((prevstate) => ({
            selectedItems: {
                [value]: active,
                ...prevstate.selectedItems
            }
        }));
    };

    handleSubmit = () => {
        const { copyFrom, copyTo, selectedItems, submitting } = this.state;
        if (submitting || isEmpty(copyFrom) || isEmpty(copyTo)) {
            return null;
        }
        this.setState(() => ({ submitting: true }));
        const newCopyTo = JSON.parse(JSON.stringify(copyTo));
        if (!newCopyTo.sections) {
            newCopyTo.sections = [];
        }
        copyFrom.sections.forEach((section) => {
            const newSectionItemIdByOriginalSectionItemId = {}; // [originalSectionItemId] => newSectionItemId
            if (selectedItems[section.id]) {
                const newSection = JSON.parse(JSON.stringify(section));

                newSection.id = uuid();
                newSection.sectionItems.map((item) => {
                    const newSectionItemId = uuid();
                    newSectionItemIdByOriginalSectionItemId[item.id] = newSectionItemId;
                    item.id = newSectionItemId;
                    item.sectionId = newSection.id;

                    // mapping new ShowPreviousAnswers questionIds over
                    if (item.type.toLocaleUpperCase() === SECTION_ITEM_TYPES.SHOW_PREVIOUS_ANSWERS) {
                        get(item, 'content.questionsToDisplay', []).forEach((questionToDisplay) => {
                            questionToDisplay.id = uuid();
                            questionToDisplay.questionId =
                                newSectionItemIdByOriginalSectionItemId[questionToDisplay.questionId];
                        });
                    }

                    return item;
                });

                newCopyTo.sections.push(newSection);
            }
        });

        return this.props
            .onSubmit(newCopyTo)
            .then((asset) => {
                this.setState(() => ({
                    submitting: false,
                    submitMessage: (
                        <p>
                            The sections were copied over successfully! Please go to
                            <Link to={`/editlearningasset/${asset._id}/summary`}>{asset.name}</Link> to reorder or edit
                            the sections.
                        </p>
                    )
                }));
            })
            .catch((err) => {
                this.setState(() => ({
                    submitting: false,
                    submitMessage: <p>There was an error copying sections. Error: {err.message}</p>
                }));
            });
    };

    render() {
        const { learningAssets, onCancel } = this.props;
        const { copyFrom, selectedItems, submitting, submitMessage } = this.state;
        return (
            <div className={'col-sm-8 copy-form'}>
                <div className={'row'}>
                    <div className={'col-sm-12'}>
                        <h4>COPY FROM</h4>
                        <AssetSelection
                            onChange={(value) => this.onAssetChange(value, 'copyFrom')}
                            learningAssets={learningAssets}
                        />
                    </div>
                </div>
                <div className={'row'}>
                    {!isEmpty(copyFrom) ? (
                        <SectionSelect
                            selectedItems={selectedItems}
                            onChange={this.onSectionChange}
                            sections={copyFrom.sections}
                        />
                    ) : null}
                </div>
                <div className={'row'}>
                    <div className={'col-sm-12'}>
                        <h4>COPY TO</h4>
                        <AssetSelection
                            onChange={(value) => this.onAssetChange(value, 'copyTo')}
                            learningAssets={learningAssets}
                        />
                    </div>
                </div>
                <div className={'row'}>
                    <div className={'col-12 formButtons'}>
                        <VerbButton fontAwesomeIcon={'fa-save'} onClick={this.handleSubmit} disabled={submitting}>
                            Save
                        </VerbButton>
                        <VerbButton
                            buttonType={VERB_BUTTON_TYPE.SECONDARY_DEFAULT}
                            fontAwesomeIcon={'fa-ban'}
                            onClick={onCancel}
                            disabled={submitting}
                        >
                            Cancel
                        </VerbButton>
                    </div>
                </div>
                <div className={'row'}>
                    <div className={'col-12 formButtons'}>{submitMessage}</div>
                </div>
            </div>
        );
    }
}

export default CopySectionForm;
